import * as React from "react";
import { PropertyAboutThisProperty as SharedUiPropertyAboutThisProperty } from "@shared-ui/lodging-property-details";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { UitkSpacing } from "uitk-react-spacing";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { inject, observer } from "mobx-react";

const WrappedPropertyAboutThis = PropertyBexApiWrapper(SharedUiPropertyAboutThisProperty);

interface IModelAboutThis {
  columns: number;
}

export const PropertyAboutThis = inject(
  "flexModuleModelStore",
  "context"
)(
  observer(({ context, flexTemplateNode, flexModuleModelStore }: ComponentProps) => {
    /* istanbul ignore next */
    const model = flexModuleModelStore?.getModel(flexTemplateNode!.id) as IModelAboutThis | null;
    /* istanbul ignore next */
    if (!model) return null;

    return (
      <UitkSpacing margin={{ block: "three" }}>
        <section>
          <WrappedPropertyAboutThis context={context} columns={model.columns} />
        </section>
      </UitkSpacing>
    );
  })
);

export default PropertyAboutThis;
